import type { ReactElement } from "react";

import Svg, { Path } from "react-native-svg";

const ArrowBulletSVG = ({
  height,
  width,
}: Partial<SizeDimensions>): ReactElement<Partial<SizeDimensions>, "svg"> => (
  <Svg fill="none" height={height} viewBox="0 0 18 12" width={width}>
    <Path
      d="M0.454 6.495c1.929.07 3.86.088 5.795.084 1.926-.003 3.853-.029 5.782-.065.54-.01 1.082-.021 1.623-.033.27-.006.54-.005.81-.003.14.001.279-.002.418.004.069.003.114.006.18-.044a.738.738 0 0 0 .26-.158c.058-.024.092-.173.11-.244.05-.19.08-.406.1-.602.02-.196.038-.408.03-.608a1.073 1.073 0 0 0-.057-.257c-.063-.024-.126-.043-.181-.091a.306.306 0 0 0-.139-.094c-.126-.012-.267.023-.395.031-.245.017-.49.036-.736.045-.48.016-.96.031-1.441.046-.97.029-1.939.055-2.908.077-1.93.045-3.859.08-5.787.103-1.091.013-2.184.049-3.276.08-.134.003-.201.721-.215.855-.011.111-.1.871.029.875Z"
      fill="#007F79"
    />
    <Path
      d="M7.625 2.21c.66.576 1.461.987 2.239 1.384.778.397 1.49.754 2.238 1.122 1.521.75 3.053 1.48 4.599 2.177.048-.696.096-1.392.143-2.088-1.892 1.009-4.057 1.388-5.913 2.477a6.65 6.65 0 0 0-.713.477 2.16 2.16 0 0 0-.357.293c-.165.17-.259.43-.355.643a2.57 2.57 0 0 0-.176.9c-.002.125-.042.561.124.607.073.02.165.054.242.037a1.33 1.33 0 0 0 .355-.274c.2-.16.41-.309.627-.447.441-.28.908-.517 1.387-.724.992-.429 2.024-.754 3.029-1.151.573-.227 1.134-.482 1.671-.784.098-.055.167-.399.183-.474.048-.222.077-.447.093-.673.014-.201.026-.414-.003-.615a.406.406 0 0 0-.13-.326c-1.534-.646-3.062-1.305-4.577-1.991-.752-.341-1.5-.687-2.246-1.04-.37-.174-.744-.338-1.12-.5-.187-.08-.372-.164-.56-.242-.197-.081-.397-.113-.607-.149-.21-.036-.329 1.221-.174 1.356Z"
      fill="#007F79"
    />
  </Svg>
);

export default ArrowBulletSVG;
